import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { getConfig, isConfigLoaded } from "../config";

i18n.use(HttpBackend).use(LanguageDetector).use(initReactI18next);

export async function initializeI18n(): Promise<void> {
  if (!isConfigLoaded()) {
    throw new Error("Configuration must be loaded before initializing i18n");
  }

  const config = getConfig();

  await i18n.init({
    fallbackLng: "en",
    supportedLngs: ["en", "ar", "es", "fr"],
    debug: false,

    returnNull: false,
    returnEmptyString: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: (lng: string[], ns: string[]) => {
        return `${config.baseApiUrl}/api/v1/translations/${lng[0]}/${ns[0]}?t=${Date.now()}`;
      },
      requestOptions: {
        cache: "no-store",
      },
    },

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "agentPortalLng",
    },

    defaultNS: "agentportal-common",
    ns: [
      "agentportal-common",
      "agentportal-auth",
      "agentportal-registration",
      "agentportal-dashboard",
      "agentportal-entities",
      "agentportal-profile",
      "common",
    ],

    react: {
      useSuspense: true,
    },
  });

  console.log("i18n initialized with API URL:", config.baseApiUrl);
}

export default i18n;
